import { setStoreTypeValues } from "utils/setStoreTypeValues";

let types: any = {
  GET_ACO_AWV_REQUEST: "",
  GET_ACO_AWV_SUCCESS: "",
  GET_ACO_AWV_FAILURE: "",

  GET_ACO_METRICS_REQUEST: "",
  GET_ACO_METRICS_SUCCESS: "",
  GET_ACO_METRICS_FAILURE: "",

  UPDATE_ACO_METRICS_REQUEST: "",
  UPDATE_ACO_METRICS_SUCCESS: "",
  UPDATE_ACO_METRICS_FAILURE: "",

  REFRESH_MEMBER_AWV_STATUS_REQUEST: "",
  REFRESH_MEMBER_AWV_STATUS_SUCCESS: "",
  REFRESH_MEMBER_AWV_STATUS_FAILURE: "",

  DOWNLOAD_MEMBER_PAFS_REQUEST: "",
  DOWNLOAD_MEMBER_PAFS_SUCCESS: "",
  DOWNLOAD_MEMBER_PAFS_FAILURE: "",

  MEMBER_STATUS_EXCEL_REQUEST: "",
  MEMBER_STATUS_EXCEL_SUCCESS: "",
  MEMBER_STATUS_EXCEL_FAILURE: "",
};

types = setStoreTypeValues(types, "hmo");

export default types;
